//E:\SAUDIDUNES11\frontend\src\App.js
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import CarPage from "./pages/CarPage";
import CarListPage from "./pages/CarListPage";
import RegisterPage from "./pages/RegisterPage";
import UserDashboard from "./components/UserDashboard";

import AirbagChapter from "./pages/CarDesignBook/AirbagChapter";
import PrefaceChapter from "./pages/CarDesignBook/PrefaceChapter";
import IgnitionChapter from "./pages/CarDesignBook/IgnitionChapter";
import FuelInjectionChapter from "./pages/CarDesignBook/FuelInjectionChapter";
import ComputerSystemsChapter from "./pages/CarDesignBook/ComputerSystemsChapter";
import CarDesign from "./pages/CarDesign";
import CarDesignOutlet from "./components/CarDesignOutlet";

import TadawulPage from "./pages/Stocks/TadawulPage";
import CryptoPage from "./pages/Stocks/CryptoPage";
import MetalsPage from "./pages/Stocks/MetalsPage";
import EtfPage from "./pages/Stocks/EtfPage";
import GISPage from "./pages/GISPage";

import StocksOutlet from "./components/StocksOutlet";

import TradersPage from "./pages/TradersPage";
import TradersOutlet from "./components/TradersOutlet";
import Chinese1 from "./pages/Traders/Chinese1";
import Chinese2 from "./pages/Traders/Chinese2";
import Chinese3 from "./pages/Traders/Chinese3";
import Chinese4 from "./pages/Traders/Chinese4";
import Chinese5 from "./pages/Traders/Chinese5";
import Chinese6 from "./pages/Traders/Chinese6";

import HomeOutlet from "./components/HomeOutlet";
import RealEstateListPage from "./pages/RealEstateListPage";
import RealEstatePage from "./pages/RealEstatePage";
import NewRealEstate from "./components/NewRealEstate";
import StorePage from "./pages/StorePage";
import BuildingDesignerPage from "./pages/BuildingDesignerPage";

function App() {
  // Read the user directly from localStorage on every render instead of
  // mirroring it in useState with a useEffect. The old approach suffered
  // from stale state (log in / log out would leave App's user state out
  // of sync with localStorage, forcing a double-click on Sign In / Register
  // before the <Navigate> route guard let the user through). Reading
  // synchronously here means the guard always sees the current value.
  useLocation(); // trigger a re-render on every route change
  const stored = localStorage.getItem("user");
  const user = stored ? JSON.parse(stored) : null;

  return (
    <HelmetProvider>
      <Routes>
        {/* ⭐ EVERYTHING THAT USES HomeNavbar MUST BE INSIDE HomeOutlet ⭐ */}
        <Route element={<HomeOutlet />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/cars/:country" element={<CarListPage />} />
          <Route path="/realestates/:type" element={<RealEstateListPage />} />
          <Route path="/car/:id" element={<CarPage />} />
          <Route path="/realestate/item/:id" element={<RealEstatePage />} />
          <Route path="/store/:id" element={<StorePage />} />
          <Route path="/gis" element={<GISPage />} />
          <Route
            path="/building-designer"
            element={<BuildingDesignerPage />}
          />
        </Route>

        {/* AUTH */}
        <Route
          path="/login"
          element={user ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/" replace /> : <RegisterPage />}
        />
        <Route
          path="/dashboard"
          element={user ? <UserDashboard /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/post-realestate"
          element={user ? <NewRealEstate /> : <Navigate to="/login" replace />}
        />

        {/* CAR DESIGN */}
        <Route element={<CarDesignOutlet />}>
          <Route path="/car-design" element={<CarDesign />} />
          <Route path="/car-design/airbag" element={<AirbagChapter />} />
          <Route path="/car-design/preface" element={<PrefaceChapter />} />
          <Route path="/car-design/ignition" element={<IgnitionChapter />} />
          <Route
            path="/car-design/fuel-injection"
            element={<FuelInjectionChapter />}
          />
          <Route
            path="/car-design/computers"
            element={<ComputerSystemsChapter />}
          />
        </Route>

        {/* STOCKS
            Phase 2B: each stock market gets its own URL so Google can
            index and rank them individually. All 9 stock-market URLs
            render TadawulPage; StocksOutlet reads the market from the
            URL and sets it in context so TadawulPage picks it up. */}
        <Route
          path="/stocks"
          element={<Navigate to="/stocks/all_stock_markets" replace />}
        />
        <Route element={<StocksOutlet />}>
          <Route path="/stocks/all_stock_markets" element={<TadawulPage />} />
          <Route path="/stocks/tadawul" element={<TadawulPage />} />
          <Route path="/stocks/nasdaq" element={<TadawulPage />} />
          <Route path="/stocks/dj" element={<TadawulPage />} />
          <Route path="/stocks/sp500" element={<TadawulPage />} />
          <Route path="/stocks/psx" element={<TadawulPage />} />
          <Route path="/stocks/nse" element={<TadawulPage />} />
          <Route path="/stocks/egx" element={<TadawulPage />} />
          <Route path="/stocks/qse" element={<TadawulPage />} />
          <Route path="/stocks/dfm" element={<TadawulPage />} />
          <Route path="/stocks/crypto" element={<CryptoPage />} />
          <Route path="/stocks/metals" element={<MetalsPage />} />
          <Route path="/stocks/etf" element={<EtfPage />} />
        </Route>

        {/* TRADERS */}
        <Route element={<TradersOutlet />}>
          <Route path="/traders" element={<TradersPage />} />
          <Route path="/traders/Chinese1" element={<Chinese1 />} />
          <Route path="/traders/Chinese2" element={<Chinese2 />} />
          <Route path="/traders/Chinese3" element={<Chinese3 />} />
          <Route path="/traders/Chinese4" element={<Chinese4 />} />
          <Route path="/traders/Chinese5" element={<Chinese5 />} />
          <Route path="/traders/Chinese6" element={<Chinese6 />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}

export default App;
